angular.module('rjmNg.api').factory("ExportApiKey", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->
    ExportApiKey = $resource(phpServiceUrl("/client/:clientId/exportapikey/:id"))
  ]
)
